import React from "react";
import Navbar from "../../components/agent/common/Navbar";
import MainSetting from "../../components/setting/MainSetting";

const Settings = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="p-4 md:p-8">
        <MainSetting />
      </main>
    </div>
  );
};

export default Settings;
